/**
 * Service de réinitialisation de mot de passe via Keycloak
 */

const getGatewayUrl = () => process.env.REACT_APP_U1_GATEWAY_BASE_URL || '/gateway';

const API_ENDPOINTS = {
    FORGOT_PASSWORD: '/forgot-password'
};

const MESSAGE_KEYS = {
    NETWORK_ERROR: 'NETWORKERROR',
    INVALID_EMAIL: 'INVALIDEMAIL',
    SERVER_ERROR: 'SERVERERROR',
    SUCCESS: 'MAILSENT'
};

const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const requestPasswordReset = async (email) => {
    if (!email || !isValidEmail(email)) {
        return {
            success: false,
            messageKey: MESSAGE_KEYS.INVALID_EMAIL
        };
    }

    try {
        const response = await fetch(getGatewayUrl() + API_ENDPOINTS.FORGOT_PASSWORD, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({ email })
        });

        if (!response.ok) {
            return {
                success: false,
                messageKey: MESSAGE_KEYS.SERVER_ERROR
            };
        }

        return {
            success: true,
            messageKey: MESSAGE_KEYS.SUCCESS
        };

    } catch (error) {
        console.error('[PASSWORD RESET ERROR]', error);
        return {
            success: false,
            messageKey: MESSAGE_KEYS.NETWORK_ERROR
        };
    }
};
